<div fxLayout="column">
    <mat-card [style.background-color]="uiData.atp.color">
        <mat-card-title>
            {{deficiencyData.id !== 0 ? 'Edit Deficiency ' + deficiencyData.id : 'Add Deficiency'}}
        </mat-card-title>
    </mat-card>
    <div class="scroll-container">
        <form [formGroup]="deficiencyDataForm" fxLayout="column">
            <div fxLayout="column">
                <div fxFlex="100" fxLayout="row" fxLayout.lt-md="column">
                    <div fxLayout="column" fxFlex="100">                                     
                        <span><strong>Deficiency Type</strong></span>  
                        <mat-form-field>
                            <input matInput formControlName="deficiencyType" placeholder="Deficiency Type">
                        </mat-form-field>                              
                    </div>
                    &nbsp;&nbsp;
                    <div fxLayout="column" fxFlex="100">                                     
                        <span><strong>Date</strong></span>                                                            
                        <mat-form-field style="width: 100%;">
                            <input matInput [matDatepicker]="letterDateTimePicker" placeholder="Date" formControlName="date" (focus)="letterDateTimePicker.open()">
                            <mat-datepicker-toggle matSuffix [for]="letterDateTimePicker"></mat-datepicker-toggle>
                            <mat-datepicker #letterDateTimePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    &nbsp;&nbsp;
                    <div fxLayout="column" fxFlex="100">    
                        <span><strong>Status</strong></span> 
                        &nbsp;&nbsp;                                  
                        <mat-checkbox formControlName="isResolved">
                            <label>{{ "Is Resolved" }}</label>                                    
                        </mat-checkbox>
                    </div>
                </div>
                &nbsp;&nbsp;
                <div fxflex="100" fxLayout="column">
                    <div fxLayout="column" fxFlex="100">  
                        <span><strong>Description</strong></span>                                     
                        <mat-form-field appearance="fill">
                            <textarea matInput formControlName="description" placeholder="Type your description here" style="height: 200px;"></textarea>
                        </mat-form-field>                              
                    </div>
                </div>
            </div>
        </form>                
    </div>
    <mat-card [style.background-color]="uiData.atp.color" fxLayout="row wrap" fxLayoutGap="8px">
        <button mat-raised-button color="primary" aria-label="Save" (click)="savePrompt()">
            {{deficiencyData.id !== 0 ? 'Save' : 'Add'}}
        </button>
        <button mat-raised-button mat-dialog-close="Exit" aria-label="Exit">Exit</button>
    </mat-card>
</div>